import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const SeriesShortLabelLink = styled(EntityLink)`
  color: #4585ff;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  text-transform: uppercase;
`;
